/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_RestrictInputs */

const en_privacy_rights_item_restrict = /** @type {(inputs: Privacy_Rights_Item_RestrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right to restriction of processing`)
};

const de_privacy_rights_item_restrict = /** @type {(inputs: Privacy_Rights_Item_RestrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht auf Einschraenkung der Verarbeitung`)
};

const fr_privacy_rights_item_restrict = /** @type {(inputs: Privacy_Rights_Item_RestrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droit à la limitation du traitement`)
};

const es_privacy_rights_item_restrict = /** @type {(inputs: Privacy_Rights_Item_RestrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derecho a la limitación del tratamiento`)
};

const it_privacy_rights_item_restrict = /** @type {(inputs: Privacy_Rights_Item_RestrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diritto alla limitazione del trattamento`)
};

const nl_privacy_rights_item_restrict = /** @type {(inputs: Privacy_Rights_Item_RestrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht op beperking van verwerking`)
};

const pl_privacy_rights_item_restrict = /** @type {(inputs: Privacy_Rights_Item_RestrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawo do ograniczenia przetwarzania`)
};

const fi_privacy_rights_item_restrict = /** @type {(inputs: Privacy_Rights_Item_RestrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oikeus käsittelyn rajoittamiseen`)
};

const da_privacy_rights_item_restrict = /** @type {(inputs: Privacy_Rights_Item_RestrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ret til begrænsning af behandling`)
};

const sv_privacy_rights_item_restrict = /** @type {(inputs: Privacy_Rights_Item_RestrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rätt till begränsning av behandling`)
};

/**
* | output |
* | --- |
* | "Right to restriction of processing" |
*
* @param {Privacy_Rights_Item_RestrictInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_restrict = /** @type {((inputs?: Privacy_Rights_Item_RestrictInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_RestrictInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_restrict(inputs)
	if (locale === "fr") return fr_privacy_rights_item_restrict(inputs)
	if (locale === "es") return es_privacy_rights_item_restrict(inputs)
	if (locale === "it") return it_privacy_rights_item_restrict(inputs)
	if (locale === "nl") return nl_privacy_rights_item_restrict(inputs)
	if (locale === "pl") return pl_privacy_rights_item_restrict(inputs)
	if (locale === "fi") return fi_privacy_rights_item_restrict(inputs)
	if (locale === "da") return da_privacy_rights_item_restrict(inputs)
	if (locale === "sv") return sv_privacy_rights_item_restrict(inputs)
	return en_privacy_rights_item_restrict(inputs)
});